import { Box, Link, Typography } from '@mui/material';
import QAIllustration from '@/illustrations/QAIllustration';
import { ArrowForwardRounded } from '@mui/icons-material';

const FAQSection = () => {
  return (
    <Box display="flex" alignItems="center" flexDirection="column" mt={2}>
      <Box
        sx={{
          maxWidth: 354,
          width: '100%',
          borderRadius: 1,
          border: (theme) => `2px solid ${theme.palette.grey[200]}`,
        }}
        display="flex"
        justifyContent="center"
        alignItems="center"
        flexDirection="column">
        <Box mt={2}>
          <QAIllustration />
        </Box>
        <Typography
          variant="h6"
          sx={{ fontWeight: 700, color: (theme) => theme.palette.grey[600], mt: 1.5 }}>
          Questions?
        </Typography>

        <Typography variant="body1" color="primary" sx={{ mt: 1.7, mb: 2 }}>
          <Link
            target="_blank"
            href={process.env.NEXT_PUBLIC_SITEVAULT_FAQ_EXTERNAL_URL}
            underline="none"
            sx={(theme) => {
              return {
                color: theme.palette.primary.main,
                '&:hover': {
                  color: theme.palette.primary.main,
                  opacity: 0.8,
                },
              };
            }}>
            Review FAQs
            <ArrowForwardRounded fontSize="small" sx={{ position: 'relative', top: 3 }} />
          </Link>
        </Typography>
      </Box>
    </Box>
  );
};

export default FAQSection;
